import { FC, JSX, useContext, useEffect, useState } from "react";
import moment from "moment";
import { QESDateInput } from "@app/shared/qes-standards/forms/DateInput";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { SoftwareRelease } from "@app/software-releases" 
import { QESButton } from "@app/shared/qes-standards/Button";

interface SoftwareReleaseDetailEditPanelProps {
  softwareRelease: SoftwareRelease;
  onSubmit: (softwareRelease: SoftwareRelease) => void;
}

export const SoftwareReleaseDetailEditPanelContent: FC<SoftwareReleaseDetailEditPanelProps> = (props: SoftwareReleaseDetailEditPanelProps): JSX.Element => {

  const flyoutContext = useContext(FlyoutContext);
  const todaysDate = moment();
  const twoYearsAgoDate = moment().subtract(2, 'years');

  const [softwareRelease, setSoftwareRelease] = useState(props.softwareRelease)
  const [dateReleasedValid, setDateReleasedValid] = useState(true);

  useEffect(() => {
    setDateReleasedValid(moment(softwareRelease.dateReleased) > twoYearsAgoDate && moment(softwareRelease.dateReleased) < todaysDate)
  }, [softwareRelease]);

  return (
    <>
      <QESDateInput
        errorText="Please enter a valid Release Date"
        isValid={dateReleasedValid}
        label="Release Date"
        max={todaysDate.format("YYYY-MM-DD")}
        min={twoYearsAgoDate.format("YYYY-MM-DD")}
        onChange={(e) => {
          setSoftwareRelease({ ...softwareRelease, dateReleased: moment(e.target.value).toDate() });
        }}
        required={true}
        testId="access-reports-dashboard__usage-report--start-date"
        value={moment(softwareRelease.dateReleased).format("YYYY-MM-DD")}
      />
      <FlyoutFooter
        submitButton={
          <QESButton qesTestId="update-release-edit-panel-content__submit"
            onClick={() => {
              props.onSubmit(softwareRelease);
              flyoutContext.handleCloseFlyout();
            }}
            disabled={!dateReleasedValid}
          >
            Submit
          </QESButton>
        }
      />
    </>
  );
}
